import { Builder } from '@builder.io/react';
import EventsBanner from './index';

Builder.registerComponent(EventsBanner, {
  name: 'EventsBanner',
  inputs: [
    {
      name: 'date',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'text',
          type: 'string'
        },
        {
          name: 'href',
          type: 'string'
        },
        {
          name: 'type',
          type: 'string',
          defaultValue: 'primary',
          enum: ['primary', 'secondary']
        },
        {
          name: 'variant',
          type: 'string',
          defaultValue: 'white-transparent',
          enum: ['default', 'black', 'black-transparent', 'white-transparent']
        },
        {
          name: 'size',
          type: 'string',
          defaultValue: 'small',
          enum: ['small', 'medium']
        }
      ]
    },
    {
      name: 'withCalendarIcon',
      helperText: `enable to show calendar icon if doesn't have avatar speaker or is a Scale Events`,
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'speakers',
      type: 'list',
      defaultValue: [
        {
          iconRounded: true,
          image:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F4d7e9097b4f74ea5ab13e9d2802bbe29',
          alt: 'eric-chu',
          name: 'Eric Chu, Head of Data Science and Engineering at Zoox'
        }
      ],
      subFields: [
        {
          name: 'iconRounded',
          type: 'boolean'
        },
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F4d7e9097b4f74ea5ab13e9d2802bbe29'
        },
        {
          name: 'alt',
          type: 'string'
        },
        {
          name: 'name',
          type: 'string'
        }
      ]
    }
  ]
});
